import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const FinancialFields = ({ itemFormData, setItemFormData }) => {
  const [projectedSaleWithoutFeesAndShipping, setProjectedSaleWithoutFeesAndShipping] = useState('');
  const [projectedSaleWithFees, setProjectedSaleWithFees] = useState('');
  const [projectedSaleWithFeesAndShipping, setProjectedSaleWithFeesAndShipping] = useState('');

  useEffect(() => {
    const calculateProjectedSales = () => {
      const minimumReturn = parseFloat(itemFormData.minimum_return) || 0;
      const estimatedShipping = parseFloat(itemFormData.estimated_shipping) || 0;

      const saleWithoutFeesAndShipping = minimumReturn * 1.30 + 3.5;
      const saleWithFees = saleWithoutFeesAndShipping * 1.15;
      const saleWithFeesAndShipping = saleWithoutFeesAndShipping * 1.15 + estimatedShipping;

      setProjectedSaleWithoutFeesAndShipping(saleWithoutFeesAndShipping.toFixed(2));
      setProjectedSaleWithFees(saleWithFees.toFixed(2));
      setProjectedSaleWithFeesAndShipping(saleWithFeesAndShipping.toFixed(2));
    };

    calculateProjectedSales();
  }, [itemFormData.minimum_return, itemFormData.estimated_shipping]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemFormData({ ...itemFormData, [name]: parseFloat(value) });
  };

  const handleCheckboxChange = () => {
    setItemFormData((prevData) => ({
      ...prevData,
      is_media_mail: !itemFormData.is_media_mail
    }));
  };

  const handleCheckboxKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleCheckboxChange();
    }
  };

  return (
    <div>
      <form>
        <div>
          <label htmlFor="minimumReturn">Minimum Return:</label>
          <input
            type="number"
            step="0.01"
            name="minimum_return"
            value={itemFormData.minimum_return}
            onChange={handleChange}
            placeholder="Enter minimum return"
            />
        </div>
        <label htmlFor="mediaMailCheckbox">Media Mail:</label>
        <input
          type="checkbox"
          id="mediaMailCheckbox"
          name="mediaMailCheckbox"
          checked={itemFormData.is_media_mail}
          onChange={handleCheckboxChange}
          onKeyDown={handleCheckboxKeyDown}
        />
        <div>
          <label htmlFor="estimatedShipping">Estimated Shipping:</label>
          <input
            type="number"
            step="0.25"
            name="estimated_shipping"
            value={itemFormData.estimated_shipping}
            onChange={handleChange}
            placeholder="Enter estimated shipping"
          />
        </div>

        <div>
          Projected Sale Price Without Shipping and Fees: {projectedSaleWithoutFeesAndShipping}
        </div>
        <div>
          Projected Sale Price With Fees: {projectedSaleWithFees}
        </div>
        <div>
          Projected Sale Price With Fees and Shipping: {projectedSaleWithFeesAndShipping}
        </div>
      </form>
    </div>
  );
};

FinancialFields.propTypes = {
  itemFormData: PropTypes.object.isRequired,
  setItemFormData: PropTypes.func.isRequired
};

export default FinancialFields;
